
// Initial scores and level information for Level 3 training

export const initialScores = {
  A: Array(3).fill(null),
  B: Array(3).fill(null),
  C: Array(3).fill(null),
  A1: Array(3).fill(null),
  B1: Array(3).fill(null),
  C1: Array(3).fill(null),
  A2: Array(3).fill(null),
  B2: Array(3).fill(null),
  C2: Array(3).fill(null),
  A3: Array(3).fill(null),
  B3: Array(3).fill(null),
  C3: Array(3).fill(null),
  A4: Array(3).fill(null),
  B4: Array(3).fill(null),
  C4: Array(3).fill(null),
  TerPlatA: Array(10).fill(null),
  TerPlatB: Array(10).fill(null),
  TerPlatC: Array(10).fill(null),
  PenteDroitA1: Array(10).fill(null),
  PenteDroitB1: Array(10).fill(null),
  PenteDroitC1: Array(10).fill(null),
  PenteGaucheA2: Array(10).fill(null),
  PenteGaucheB2: Array(10).fill(null),
  PenteGaucheC2: Array(10).fill(null),
  ChipRoulA: Array(10).fill(null),
  ChipRoulB: Array(10).fill(null),
  ChipRoulC: Array(10).fill(null),
  ChipRoulD: Array(10).fill(null),
  ChipRoulPenteA1: Array(10).fill(null),
  ChipRoulPenteB1: Array(10).fill(null),
  ChipRoulPenteC1: Array(10).fill(null),
  ChipRoulPenteD1: Array(10).fill(null),
  ChipRoulPenteA5: Array(10).fill(null),
  ChipRoulPenteB5: Array(10).fill(null),
  ChipRoulPenteC5: Array(10).fill(null),
  ChipRoulPenteD5: Array(10).fill(null),
  WedgingA: Array(10).fill(null),
  WedgingB: Array(10).fill(null),
  WedgingC: Array(10).fill(null),
  WedgingD: Array(10).fill(null),
  WedgingE: Array(10).fill(null),
  WedgingF: Array(10).fill(null),
  WedgingA1: Array(10).fill(null),
  WedgingB1: Array(10).fill(null),
  WedgingC1: Array(10).fill(null),
  WedgingD1: Array(10).fill(null),
  WedgingE1: Array(10).fill(null),
  WedgingF1: Array(10).fill(null),
  WedgingD2: Array(10).fill(null),
  WedgingE2: Array(10).fill(null),
  WedgingF2: Array(10).fill(null),
  WedgingA2: Array(10).fill(null),
  WedgingB2: Array(10).fill(null),
  WedgingC2: Array(10).fill(null),
  BunkerA: Array(10).fill(null),
  BunkerB: Array(10).fill(null),
  BunkerC: Array(10).fill(null),
  BunkerD: Array(10).fill(null),
  IronA: Array(10).fill(null),
  IronB: Array(10).fill(null),
  IronC: Array(10).fill(null),
  IronGreenAttack100: Array(10).fill(null),
  FairwayWoodA: Array(10).fill(null),
  FairwayWoodB: Array(10).fill(null),
  FairwayWoodC: Array(10).fill(null),
};

export const levels = {
  A1: '3',
  B1: '3',
  C1: '3',
  A2: '3',
  B2: '3',
  C2: '3',
  A3: '3',
  B3: '3',
  C3: '3',
  A4: '3',
  B4: '3',
  C4: '3'
};
